<template>
  <v-app>
    <v-main>
      <app-bar v-if="!isCalendarPage"></app-bar>

      <navigation-drawer v-if="isAuthenticated && !isCalendarPage"></navigation-drawer>

      <!-- This is essential -->
      <router-view></router-view>

      <reviews-menu v-if="!isCalendarPage"></reviews-menu>
      <menu-menu v-if="!isCalendarPage"></menu-menu>
      <disputes-menu v-if="!isCalendarPage"></disputes-menu>

      <confirm-dialog></confirm-dialog>
      <v-chip v-if="true" class="position-fixed" style="bottom: 8px; right: 8px; z-index: 9999" size="x-small" color="primary" label>
        {{ name }} — {{ width }}px
      </v-chip>
    </v-main>
  </v-app>
</template>

<script setup>
import { computed, onMounted } from "vue";
import { useRoute } from "vue-router";
import { useDisplay } from "vuetify";
import { useApp } from "@/composables/useApp.js";
import { startTokenRefreshTimer, isAuthenticated as checkAuth } from "@/utils/api.js";
import { useUserPreferences } from "@/composables/useUserPreferences.js";
import AppBar from "@/components/AppBar.vue";
import NavigationDrawer from "@/components/NavigationDrawer.vue";
import SalesMenu from "@/components/SalesMenu.vue";
import ReviewsMenu from "@/components/ReviewsMenu.vue";
import MenuMenu from "@/components/FoodCostMenu.vue";
import DisputesMenu from "@/components/DisputesMenu.vue";
import ConfirmDialog from "@/components/ConfirmDialog.vue";

const route = useRoute();
const { mobile, name, width, height } = useDisplay();
const { isAuthenticated } = useApp();

// Calendar pages are standalone (no app bar or drawer)
const isCalendarPage = computed(() =>
  route.path.startsWith("/campaigns/calendar") ||
  (route.path.startsWith("/reviews-calendar") && !mobile.value)
);

const { loadPreferences } = useUserPreferences();

// Start token refresh timer and load user preferences on app load if authenticated
onMounted(() => {
  if (checkAuth()) {
    startTokenRefreshTimer();
    loadPreferences();
  }
});
</script>
